import { render, staticRenderFns } from "./ConversationV2.vue?vue&type=template&id=44df4791&scoped=true"
import script from "./ConversationV2.vue?vue&type=script&lang=js"
export * from "./ConversationV2.vue?vue&type=script&lang=js"
import style0 from "./ConversationV2.vue?vue&type=style&index=0&id=44df4791&prod&scoped=true&lang=css"
import style1 from "./ConversationV2.vue?vue&type=style&index=1&id=44df4791&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44df4791",
  null
  
)

export default component.exports